import { put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { call } from 'redux-saga/effects';
import { toast } from "react-toastify";
import httpClient from "../api/userApi/httpClient";
import { translationActions } from '../reducers/translationSlice';

function* getTranslations(action: PayloadAction<any>) {

    const { result, error, headers } = yield call(httpClient, {
        params: action.payload,
        method: "get",
        url: `/constants`
    });

    if (error) {
        yield put(translationActions.translationsListFailed(error.message)); // Dispatch action
        toast.error(error);
    } else {
        console.log(result,'result.response')
        yield put(translationActions.translationsListSuccess(result.payload))
    }
    return { error, result };
}

export function* translationSaga() {
    yield takeLatest(translationActions.translationList.type, getTranslations);
}
  